import { gql } from '@apollo/client';
import { useMutation } from 'react-query';
import { ApolloClient, NormalizedCacheObject } from '@apollo/client';

const LINK_SESSION_TO_USER = gql`
  mutation LinkSessionToUser($sessionToken: String!) {
    linkSessionToUser(sessionToken: $sessionToken) {
      success
      message
      user {
        uid
        email
        phoneNumber
        displayName
        accounts {
          profileId
          sessionId
          linkedAt
        }
      }
    }
  }
`;

const UNLINK_SESSION_FROM_USER = gql`
  mutation UnlinkSessionFromUser($sessionId: String!) {
    unlinkSessionFromUser(sessionId: $sessionId) {
      success
      message
      user {
        uid
        email
        phoneNumber
        displayName
        accounts {
          profileId
          sessionId
          linkedAt
        }
      }
    }
  }
`;

const GET_CURRENT_USER = gql`
  query GetCurrentUser {
    getCurrentUser {
      uid
      email
      phoneNumber
      displayName
      linkedSessionIds
      createdAt
      updatedAt
    }
  }
`;

const GET_LINKED_ACCOUNTS = gql`
  query GetLinkedAccounts {
    getLinkedAccounts {
      profileId
      sessionId
      linkedAt
    }
  }
`;

const GET_SESSION_INFO = gql`
  query GetSessionInfo($sessionToken: String!) {
    getSessionInfo(sessionToken: $sessionToken) {
      profileId
      accountInfo {
        name
        thumbnails {
          url
          height
          width
        }
      }
    }
  }
`;


export function useLinkSessionToUser(client: ApolloClient<NormalizedCacheObject>) {
  return useMutation(
    async (sessionToken: string) => {
      const { data } = await client.mutate({
        mutation: LINK_SESSION_TO_USER,
        variables: { sessionToken },
      });
      return data.linkSessionToUser;
    },
    {
      onSuccess: (data) => {
        console.log('Session linked successfully:', data);
      },
      onError: (error) => {
        console.error('Failed to link session:', error);
      },
    }
  );
}

export function useUnlinkSessionFromUser(client: ApolloClient<NormalizedCacheObject>) {
  return useMutation(
    async (sessionId: string) => {
      const { data } = await client.mutate({
        mutation: UNLINK_SESSION_FROM_USER,
        variables: { sessionId },
      });
      return data.unlinkSessionFromUser;
    },
    {
      onSuccess: (data) => {
        console.log('Session unlinked successfully:', data);
      },
      onError: (error) => {
        console.error('Failed to unlink session:', error);
      },
    }
  );
}

export function useGetCurrentUser(client: ApolloClient<NormalizedCacheObject>) {
  return useMutation(
    async () => {
      const { data } = await client.query({
        query: GET_CURRENT_USER,
        fetchPolicy: 'network-only', // Always fetch fresh data
      });
      return data.getCurrentUser;
    }
  );
}

export function useGetLinkedAccounts(client: ApolloClient<NormalizedCacheObject>) {
  return useMutation(
    async () => {
      const { data } = await client.query({
        query: GET_LINKED_ACCOUNTS,
        fetchPolicy: 'network-only', // Always fetch fresh data
      });
      return data.getLinkedAccounts;
    }
  );
}

export function useGetSessionInfo(client: ApolloClient<NormalizedCacheObject>) {
  return useMutation(
    async (sessionToken: string) => {
      const { data } = await client.query({
        query: GET_SESSION_INFO,
        variables: { sessionToken },
        fetchPolicy: 'network-only', // Always fetch fresh data
      });
      return data.getSessionInfo;
    },
    {
      onSuccess: (data) => {
        console.log('Session info retrieved successfully:', data);
      },
      onError: (error) => {
        console.error('Failed to get session info:', error);
      },
    }
  );
}

